export * from "./glTFFileLoader";
import * as GLTF1 from "./1.0";
import * as GLTF2 from "./2.0";
export {
    GLTF1,
    GLTF2
};
